class InternalQueryParams {
	constructor() {
		this.demoPagePath = apiSettings.requestDemo.page_url;
		this.initDemoPageModalLinks();
		this.initDemoPageLinks();
	}

	initDemoPageModalLinks = () => {
		const modalLinks = document.querySelectorAll('a[href="#show-demo-modal"]');
		modalLinks.forEach((link) => {
			link.href = this.demoPagePath; // Replace #show-demo-modal with the demo page path
		});
	};

	initDemoPageLinks = () => {
		const links = document.querySelectorAll(`a[href="${this.demoPagePath}"]`);
		if (apiSettings.internalQueryParams) {
			links.forEach((link) => this.appendParamsToLink(link, apiSettings.internalQueryParams));
		}
	};

	appendParamsToLink = (link, params) => {
		const url = new URL(link.href, window.location.origin); // Handles relative URLs correctly
		if (params.ls) {
			url.searchParams.set('LS', params.ls);
		}
		if (params.lsd) {
			url.searchParams.set('LSD', params.lsd);
		}
		if (params.la) {
			url.searchParams.set('LA', params.la);
		}
		if (params.lad) {
			url.searchParams.set('LAD', params.lad);
		}
		link.href = url.toString();
	};
}

export default InternalQueryParams;
